<template>
    <div class="standout">
        <div class="standout__title">
            <img
                width="24"
                class="standout__flag"
                v-if="item.country"
                :src="item.country.local"
                :alt="item.country.name"
            />
            <h3 v-text="item.client" class="standout__client"/>
            <span v-text="item.date" class="standout__date"/>
        </div>
        <span class="standout__counterpart" v-if="item.counterpart" v-text="item.counterpart"/>
        <DataList
            :items="[
                {
                    title: 'Deal Type',
                    value: item.deal_type,
                    icon: 'deal',
                    isSector: false,
                },
                {
                    title: 'Implied EV ($m)',
                    value: item.implied_ev,
                    icon: 'value',
                    isSector: false,
                },
                {
                    title: 'Main Sector',
                    value: item.sector,
                    isSector: true,
                },
            ]"
        />
    </div>
</template>
<script>
    import DataList from '@components/DataList/List.vue';

    export default {
        name: 'StandoutCard',
        components: { DataList },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
    }
</script>
<style lang="scss">
    @import '~@/theme/variables';

    .standout {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border: .1rem solid $border;
        border-radius: .4rem;
        padding: 2rem;
        overflow: hidden;

        .standout__title {
            display: flex;
            align-items: center;
            column-gap: 1rem;
            margin-bottom: .5rem;
            width: 100%;

            .standout__flag {

            }

            .standout__client {
                margin-bottom: 0;
                position: relative;
                top: .2rem;
                flex-grow: 1;
                font-size: 1.8rem;
                line-height: 2.3rem;
                font-weight: 500;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }

            .standout__date {
                color: $text;
                font-size: 1.4rem;
                line-height: 1.7rem;
                position: relative;
                top: .2rem;
                flex: 0 0 7.8rem;
            }
        }

        .standout__counterpart {
            font-size: 1.4rem;
            line-height: 1.7rem;
            color: $text;
            width: 100%;
        }

        .datalist {
            margin-top: 1.5rem;

            .dataitem {
                .dataitem__title {
                    font-size: 1.2rem;
                    line-height: 1.4rem;
                }
            }
        }
    }
</style>
